import Typography from "@mui/material/Typography";

export function FoundryUsage() {
  return (
    <div className="homepage">
      <Typography variant="h1" align='center' padding={'20px'}>Foundry Usage Guide</Typography>
      <Typography variant="body2" align='center'>The amount of icons and other miscellaneous things also changed here. This part is being updated!</Typography>
    </div>
  )
}